import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useScrolled } from '../hooks/useScrolled';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeToggle from './ThemeToggle';

export default function Nav() {
  const scrolled = useScrolled(40);
  const { t } = useTranslation();

  return (
    <nav
      className={`fixed inset-x-0 top-0 z-nav flex items-center justify-between transition-all duration-300 ease-soft ${
        scrolled
          ? 'border-b border-line bg-surface/90 px-4 py-3 backdrop-blur-md sm:px-6 md:px-10'
          : 'border-b border-transparent bg-transparent px-4 py-5 sm:px-6 md:px-10'
      }`}
    >
      <Link
        to="/"
        aria-label="takuna stay — home"
        onClick={() => window.scrollTo({ top: 0 })}
        className="flex items-center gap-2.5 text-ink no-underline"
      >
        <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-accent font-display text-sm font-semibold text-surface">
          t
        </span>
        <span className="hidden font-display text-[18px] font-semibold tracking-display sm:inline">
          takuna<span className="text-accent">.</span>stay
        </span>
      </Link>

      <div className="flex items-center gap-2 text-sm sm:gap-4 md:gap-6">
        <a href="/#stays" className="hidden text-ink/85 no-underline transition hover:text-ink md:inline">
          {t('nav.stays')}
        </a>
        <a href="/#difference" className="hidden text-ink/85 no-underline transition hover:text-ink md:inline">
          {t('nav.host')}
        </a>
        <ThemeToggle />
        <LanguageSwitcher />
        <a
          href="/#stays"
          className="whitespace-nowrap rounded-full bg-ink px-3.5 py-2 text-[13px] font-medium tracking-wide text-surface no-underline transition hover:opacity-90 sm:px-4 sm:py-2.5"
        >
          {t('nav.book')} <span aria-hidden>→</span>
        </a>
      </div>
    </nav>
  );
}
